import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

class Alert extends React.Component {
  componentDidUpdate (e) {
    const { fadeIn, alertType } = this.props
    if (fadeIn) {
      _.each(document.querySelectorAll(`.alert.alert--${alertType}`), (alert) => {
        alert.style.opacity = '0'
        setTimeout(() => { alert.style.opacity = '1' }, 200)
      })
    }
  }

  render () {
    const {
      showAlert,
      alertType,
      cssClasses,
      children,
      text,
      closeAlert,
      clearable
    } = this.props

    return (
      <div style={showAlert ? {} : { display: 'none' }} className={`alert alert--${alertType} ${cssClasses}`} id={`alert-${alertType}`}>
        <label htmlFor={`col_alert-${alertType}`} />
        {text || children}
        {clearable && <span className="lnr lnr-cross" onClick={() => (closeAlert())} />}
      </div>
    )
  }
}

Alert.defaultProps = {
  showAlert: true,
  fadeIn: false,
  alertType: 'notice',
  cssClasses: '',
  clearable: false,
  closeAlert: () => (this.setState({ showAlert: false }))
}

Alert.propTypes = {
  fadeIn: PropTypes.bool,
  alertType: PropTypes.string,
  text: PropTypes.string
}

export default Alert
